import {Period} from '../../common/model/period.model';
import {EntitaOrganizzativa} from '../entitaorganizzativa/entitaorganizzativa.model';
import {Persona} from '../persona/persona.model';
import {TipoAppartenenza} from './tiporelazione.enum';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {Helpers} from '../../common/helpers/helpers';

export class PersonaEntitaOrganizzativa extends Period {

  constructor(protected id: number,
                public persona: Persona,
                public entitaOrganizzativa: EntitaOrganizzativa,
                public note: string,
                public provvedimento: string,
                public tipoAppartenenza: TipoAppartenenza,
                public inizioValidita,
                public fineValidita
  ) {
    super(id, inizioValidita, fineValidita);
  }

  public static getTableKeys() {
    return ['persona', 'entitaOrganizzativa', 'tipologia', 'Inizio', 'Fine'];
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('persona', new TableRowValue(this.persona.getLabel(), null));
    rowValues.set('entitaOrganizzativa', new TableRowValue(this.entitaOrganizzativa.getSigla(), null));
    rowValues.set('tipologia', new TableRowValue(this.tipoAppartenenza.getEnumValue(), null, true));
    rowValues.set('Inizio', new TableRowValue(Helpers.formatDateView(this.getInizio()), null));
    rowValues.set('Fine', new TableRowValue(Helpers.formatDateView(this.getFine()), null));
    return new TableRow(this, rowValues);
  }

  public getLabel() {
    return 'Assegnazione ' + this.persona.getLabel()
      + ' - ' + this.entitaOrganizzativa.getLabel();
  }

}

